<template>
  <vs-popup
    id="popup-historico-forca"
    title="Histórico de Disponibilidade"
    :active.sync="ativoInterno"
    @click.native.stop
  >
    <div style="max-height: 380px; overflow-y: auto; padding-right: 4px;">
      <p class="mb-3" style="color: #666; font-size: 13px;">
        Dias analisados para encontrar disponibilidade na data {{ dataOriginalFormatada }}
      </p>
      <div
        v-for="(item, idx) in historicoCompleto"
        :key="idx"
        class="mb-3 p-3"
        :style="
          item.disponivel
            ? 'border-left: 3px solid #28a745; background: #f0fff4; border-radius: 4px;'
            : 'border-left: 3px solid #FF9900; background: #fff8f0; border-radius: 4px;'
        "
      >
        <div style="display: flex; align-items: center; gap: 6px; margin-bottom: 4px;">
          <i
            class="material-icons"
            :style="
              item.disponivel
                ? 'color: #28a745; font-size: 16px;'
                : 'color: #FF9900; font-size: 16px;'
            "
          >{{ item.disponivel ? 'event_available' : 'event_busy' }}</i>
          <strong style="color: #333; font-size: 13px;">{{ formatarData(item.data) }}</strong>
        </div>
        <p
          :style="
            item.disponivel
              ? 'color: #28a745; font-size: 12px; margin: 0; font-weight: 600;'
              : 'color: #555; font-size: 12px; margin: 0;'
          "
        >{{ item.disponivel ? 'Disponível' : item.motivo }}</p>
      </div>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'ModalHistoricoBuscaForca',
  props: {
    ativo: {
      type: Boolean,
      default: false
    },
    historico: {
      type: Array,
      default: () => []
    },
    dataSelecionada: {
      type: String,
      default: null
    },
    disponivel: {
      default: null
    }
  },
  computed: {
    ativoInterno: {
      get () { return this.ativo; },
      set (val) { this.$emit('update:ativo', val); }
    },
    historicoCompleto () {
      const falhas = [...(this.historico || [])].map(f => ({ ...f, disponivel: false }));
      if (this.disponivel == 1 && this.dataSelecionada) {
        falhas.push({ data: this.dataSelecionada, motivo: null, disponivel: true });
      }
      return falhas.sort((a, b) => (a.data > b.data ? 1 : -1));
    },
    dataOriginalFormatada () {
      let d = this.dataSelecionada;
      if (this.historico && this.historico.length > 0) {
        d = this.historico[0].data;
      }
      return this.formatarData(d);
    }
  },
  methods: {
    formatarData (data) {
      if (!data) return '';
      const parts = data.split('-');
      return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }
  }
};
</script>
